<template>
  <div id="app" :class="[showMenu ? 'noscroll' : '', $route.name == 'index' ? 'home' : 'nonhome']">
    <header id="header">
      <div class="inner">
        <a aria-label="Menu" href class="menu-link" @click.prevent="showMenu = !showMenu">
          <transition name="fade">
            <i v-if="!showMenu" class="las la-grip-lines"></i>
            <i v-else class="las la-times"></i>
          </transition>
        </a>
        <nav :class="showMenu ? 'show' : ''">
          <div class="nav-links">
            <div>
              <router-link to="/" @click.native="closeMenu">Home</router-link>
              <router-link to="/about-us" @click.native="closeMenu">About Us</router-link>
              <router-link to="/tree-surgery" @click.native="closeMenu">Services</router-link>
              <router-link to="/equipment" @click.native="closeMenu">Equipment</router-link>
              <router-link to="/contact-us" @click.native="closeMenu">Contact</router-link>
            </div>
          </div>
        </nav>

        <router-link to="/" class="logo">
          <img src="/images/precision-tree-care-g.png" alt="Precision Tree Care in the Peak District" />
        </router-link>
        <div class="social">
          <a aria-label="Email" href="mailto:precisiontreecare@hotmail.co.uk"><i class="las la-envelope"></i></a>
          <a aria-label="Telephone" class="mobile" href="tel:07793064684"><i class="las la-phone"></i></a>

          <a
            class="nomobile"
            aria-label="Facebook"
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/Precision-Tree-Care-534172156794116/"
          >
            <i class="lab la-facebook"></i
          ></a>
          <a
            class="nomobile"
            aria-label="Instagram"
            target="_blank"
            rel="noreferrer"
            href="https://instagram.com/precision_tree_care"
            ><i class="lab la-instagram"></i
          ></a>
        </div>
      </div>
    </header>
    <div class="video">
      <video preload autoplay muted playsinline loop id="video">
        <source src="/video/tree-surgeon.mp4" type="video/mp4" />
        Sorry, your browser doesn't support embedded videos.
      </video>
      <div class="intro">
        <div class="inner">
          <div class="intro-main">Welcome to <span>Precision Tree Care</span></div>
          <div class="intro-sub">Tree Surgeons in the Peak District <span>with over 20 Years Experience</span></div>
          <div class="intro-actions">
            <a href="#content" class="more" v-smooth-scroll>Find out more</a>
            <a href="#form" v-smooth-scroll>Get a quote</a>
          </div>
        </div>
      </div>
      <a class="down" href="#content" aria-label="down" v-smooth-scroll>
        <i class="las la-angle-down bounce"></i>
      </a>
    </div>
    <div class="banner">
      <div class="placeholder"><img src="/images/banners/placeholder.gif" alt="Tree Surgeons Placeholder" /></div>
      <div class="slide" :class="$route.name == 'about' ? 'show' : ''">
        <img
          v-show="$route.name == 'about'"
          src="/images/banners/about.jpg"
          alt="About Peak District Tree Surgeons"
        /><span>About Our Team</span>
      </div>
      <div class="slide" :class="$route.name == 'services' ? 'show' : ''">
        <img src="/images/banners/services.jpg" alt="Peak District Tree Surgery Services" /><span
          >Our Tree Services</span
        >
      </div>
      <div class="slide" :class="$route.name == 'equipment' ? 'show' : ''">
        <img src="/images/banners/equipment.jpg" alt="Peak District Tree Surgery Equipment" /><span
          >Specialist Equipment</span
        >
      </div>
      <div class="slide" :class="$route.name == 'contact' ? 'show' : ''">
        <img src="/images/banners/contact.jpg" alt="Contact Peak District Tree Surgeons" /><span>Contact Us</span>
      </div>
      <div class="slide" :class="$route.name == 'privacy' ? 'show' : ''">
        <img src="/images/banners/contact.jpg" alt="Peak District Tree Surgeons Privacy" /><span>Privacy Policy</span>
      </div>
    </div>
    <router-view :key="$route.fullPath" />
    <contact-form></contact-form>
    <reviews></reviews>
    <gallery></gallery>
    <footer id="footer">
      <div class="inner">
        <div class="footer-col">
          <div class="footer-header">Stay connected</div>
          <a target="_blank" rel="noreferrer" href="https://www.facebook.com/Precision-Tree-Care-534172156794116/">
            <i class="lab la-facebook"></i> Find us on Facebook</a
          >
          <a target="_blank" rel="noreferrer" href="https://instagram.com/precision_tree_care"
            ><i class="lab la-instagram"></i> Follow us on Instagram</a
          >
        </div>
        <div class="footer-col">
          <div class="footer-header">Get in touch</div>

          <a href="mailto:precisiontreecare@hotmail.co.uk"
            ><i class="las la-envelope"></i> precisiontreecare@hotmail.co.uk</a
          >
          <a href="tel:07793064684"><i class="las la-phone"></i> 07793064684</a>
        </div>
        <div class="footer-col our-services">
          <div class="footer-header">Our Services</div>

          <router-link to="/tree-surgery">Tree Surgery</router-link>
          <router-link to="/tree-surgery" @click.native="scrollFix('#forestry')">Forestry</router-link>
          <router-link to="/tree-surgery" @click.native="scrollFix('#siteclearance')">Site Clearance</router-link>
          <router-link to="/tree-surgery" @click.native="scrollFix('#firewood')">Firewood Supply</router-link>
        </div>
        <router-link to="/" class="logo">
          <img src="/images/precision-tree-care-w.png" alt="Precision Tree care in the Peak District" />
        </router-link>
      </div>
    </footer>
    <div class="legal">
      <div class="inner">
        <router-link to="/privacy">Privacy Policy</router-link>
        <div>&copy; Precision Tree Care <span>|</span> Grindleford Road, Hope Valley S32 3XH</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMenu: false,
      menu: [
        {
          name: "home",
          url: "/"
        },
        {
          name: "about us",
          url: "/about-us"
        },
        {
          name: "services",
          url: "/tree-surgery"
        },
        {
          name: "contact us",
          url: "/contact-us"
        }
      ]
    }
  },
  methods: {
    scrollFix: function(hash) {
      setTimeout(() => document.getElementById(hash.replace("#", "")).scrollIntoView({ behavior: "smooth" }), 1)
    },
    closeMenu: function() {
      this.showMenu = false
    }
  },
  created: function() {
    window.onscroll = function() {
      var header = document.getElementById("header")

      if (window.pageYOffset > header.offsetHeight) {
        header.classList.add("scrolled")
      } else {
        header.classList.remove("scrolled")
      }
    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title,
      meta: [{ name: "description", content: this.$route.meta.description }]
    }
  },
  watch: {
    $route() {
      this.showMenu = false
    }
  }
}
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@300;500;700&family=Unica+One&display=swap");

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

*:focus {
  outline: none !important;
}

a {
  color: inherit;
  text-decoration: none;
}

img {
  max-width: 100%;
}

html,
body {
  padding: 0;
  margin: 0;
  scroll-behavior: smooth;
}

body {
  box-sizing: border-box;
  line-height: 1.5;
}

html {
  font-size: 62.5%;
  color: #272425;
}

body,
input,
select,
textarea,
button {
  font-family: "Libre Franklin", sans-serif;
  font-size: 1.7rem;
  font-weight: 300;
}

#header {
  padding: 2rem 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;
  transition: all 0.5s;
  height: 10rem;
}

#header.scrolled {
  position: fixed;
  background: white;
  z-index: 20;
  padding: 1rem 0;
  box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.2);
}

#header .logo {
  display: block;
  width: 12rem;
  transition: all 0.5s;
  position: absolute;
  left: 0%;
  top: 0;
  z-index: 12;
}

#header .logo {
  filter: contrast(0) brightness(200%);
}

#header.scrolled .logo {
  filter: none;
  width: 8rem;
}

#header.scrolled nav,
#header.scrolled .social {
  color: black;
  text-shadow: none;
}

#header.scrolled .menu-link {
  color: black;
}

.video {
  background: #000;
  left: 0;
  top: 0;
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 2;
  height: 95vh;
}

.nonhome .video {
  height: 0;
  overflow: hidden;
}

.banner {
  top: -100vh;
  left: 0;
  width: 100%;
  position: absolute;
  z-index: 1;
  background: black;
  line-height: 0;
}

.banner .slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  transition: opacity 0.5s;
}

.banner .slide.show {
  opacity: 1;
}

.nonhome .banner {
  top: 0;
  position: relative;
}

.banner img {
  z-index: 1;
}

.banner span {
  width: 92%;
  max-width: 150rem;
  margin: auto;
  display: block;
  bottom: 15rem;
  z-index: 2;
  position: relative;
  color: white;
  font-family: "Unica One", "Roboto", Arial;
  font-size: 6rem;
  text-transform: uppercase;
  text-shadow: 0px 0px 30px rgba(0, 0, 0, 1);
  transform: translateY(-2rem);
  transition: all 1.5s;
  opacity: 0;
  line-height: 1.2;
  padding-bottom: 1rem;
}

.banner span::after {
  display: block;
  content: " ";
  position: absolute;
  bottom: 0;
  height: 1px;
  width: 0;
  right: 0;
  background: white;
  opacity: 0;
  transition: all 1.5s;
}

.banner .show span {
  transform: translateY(0);
  opacity: 1;
}

.banner .show span::after {
  width: 85%;
  opacity: 0.3;
}

#video {
  min-width: 100%;
  min-height: 95vh;
  z-index: 1;
  opacity: 0.65;
  filter: contrast(1.5);
  position: relative;
  transition: all 0.5s;
}

.nonhome #video {
  opacity: 0;
}

.inner {
  display: table;
  margin: auto;
  max-width: 150rem;
  width: 92%;
  position: relative;
}

.content {
  margin-top: 7rem;
}

.social {
  position: absolute;
  top: 3.5rem;
  right: 0;
  width: 25%;
  color: white;
  text-align: right;
  font-size: 3rem;
  z-index: 11;
}

.scrolled .social {
  top: 1.5rem;
}

.social a {
  margin-left: 1rem;
}

nav {
  position: relative;
  transition: all 0.5s;
  right: -1.25rem;
  font-size: 2rem;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  color: white;
  text-align: center;
  font-weight: 500;
  font-family: "Unica One", "Roboto", Arial;
}

nav a {
  display: inline-block;
  padding: 0;
  margin: 0 1.5%;
}

nav a.spaced {
  margin-right: 19.5rem;
  transition: margin 0.3s;
}

.nav-links {
  position: relative;
  top: 4.5rem;
  z-index: 10;
  transition: all 0.3s;
}

.scrolled .nav-links {
  top: 2.5rem;
}

.scrolled nav a.spaced {
  margin-right: 16rem;
}
.intro {
  position: absolute;
  top: 52%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  color: white;
  width: 100%;
  text-shadow: 0px 0px 30px rgba(0, 0, 0, 1);
  text-align: center;
  z-index: 4;
}

.intro span {
  white-space: nowrap;
}

.intro-main {
  font-size: 5.5rem;
  font-weight: 500;
  line-height: 1.2;
  text-transform: uppercase;
  margin-bottom: 2rem;
  font-family: "Unica One", "Roboto", Arial;
}
.intro-sub {
  font-size: 3rem;
  font-weight: 300;
  text-transform: uppercase;
  font-family: "Unica One", "Roboto", Arial;
  opacity: 0.85;
}

.intro-actions {
  margin-top: 5rem;
}

.intro-actions a {
  display: inline-block;
  background: white;
  color: #333;
  padding: 1.5rem 3rem;
  margin: 0 1rem;
  text-transform: uppercase;
  font-weight: 500;
  font-family: "Unica One", "Roboto", Arial;
  font-size: 2rem;
}

.intro-actions a.more {
  background: #007a50;
  color: white;
}

.intro-actions a:hover {
  filter: brightness(1.1);
}

.down {
  position: absolute;
  bottom: 15%;
  left: 50%;
  z-index: 4;
  transform: translateX(-50%);
  color: white;
  font-size: 5rem;
}

.bounce {
  -moz-animation: bounce 2s infinite;
  -webkit-animation: bounce 2s infinite;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    -ms-transform: translateY(-30px);
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}

#footer {
  background: #000000;
  color: white;
  padding: 6rem 0;
  padding-top: 8rem;
}

.legal {
  background: #007a50;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.3rem;
  padding-bottom: 3rem;
}

.legal a:hover {
  color: white;
}

.legal .inner {
  padding-top: 3rem;
}

.legal span {
  display: inline-block;
  margin: 0 1rem;
}

.legal a {
  float: right;
}

.footer-col {
  float: right;
  margin-left: 10rem;
}

.footer-col a {
  display: block;
  margin-bottom: 1rem;
}

.footer-col a i {
  margin-right: 0.5rem;
}

.footer-header {
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 2rem;
  font-size: 2rem;
  font-family: "Unica One", "Roboto", Arial;
}

#footer .logo {
  width: 12rem;
  display: block;
}

p {
  margin-bottom: 2rem;
}

h1,
h2 {
  font-size: 4rem;
  margin-bottom: 2rem;
  color: #007a50;
  text-transform: uppercase;
  font-family: "Unica One", "Roboto", Arial;
  line-height: 1.2;
}

h1 span {
  white-space: nowrap;
}

h2 {
  font-size: 3.5rem;
  color: #080808;
}

.section {
  display: grid;
  grid-template-columns: 2fr 1fr;
  margin-bottom: 6rem;
  padding-bottom: 6rem;
  grid-template-areas: "text image";
  gap: 5rem;
  position: relative;
  z-index: 2;
}

.section-image {
  grid-area: image;
  width: 100%;
  transition: all 1.5s;
  top: 5rem;
  position: relative;
  opacity: 1;
  z-index: 2;
}

.section::after {
  display: block;
  position: absolute;
  z-index: 1;
  width: 30%;
  height: 80%;
  content: " ";
  background: #f6f6f6;
  opacity: 0.6;
  top: 10%;
  left: 0%;
  transition: all 1.5s;
}

.section.no-shadow {
  border-top:1px solid #f5f5f5;
  border-bottom:1px solid #f5f5f5;
  padding: 5rem 0;
  margin-top:-5rem
}

.section.no-shadow::after {
  display: none;
}

.section.in-viewport::after {
  left: 10%;
}

.section:nth-child(odd)::after {
  left: auto;
  right: 0%;
}

.section.in-viewport:nth-child(odd)::after {
  right: 10%;
}

.section-text {
  grid-area: text;
  transition: all 1s;
  opacity: 0;
  top: 7rem;
  position: relative;
  z-index: 2;
}

.section-text.in-viewport,
.section-image.in-viewport {
  top: 0;
  opacity: 1;
}

.section:nth-child(even) {
  grid-template-areas: "image text";
  grid-template-columns: 1fr 2fr;
}
.content ul {
  padding-left: 2rem;
  padding-bottom: 2rem;
}

@media screen and (max-width: 1300px) {
  html {
    font-size: 55%;
  }
  .intro {
    top: 53%;
    left: 50%;
  }
}

@media screen and (max-width: 950px) {
  .intro-main {
    font-size: 4.5rem;
  }
  .intro-sub {
    font-size: 2.5rem;
  }
  .intro span {
    display: block;
  }
  .footer-col {
    float: none;
    margin-left: 0;
    margin-bottom: 5rem;
    text-align: center;
  }
  .footer-col.our-services {
    display: none;
  }
  #footer .logo {
    margin: auto;
  }
}

@media screen and (min-width: 791px) {
  .menu-link,
  .mobile {
    display: none;
  }
}

@media screen and (max-width: 790px) {
  .social a.nomobile {
    display: none;
  }
  nav {
    position: absolute;
    top: 0;
    width: 100%;
    right: auto;
    z-index: ;
  }
  #header {
    height: 8rem;
  }

  #header .logo {
    left: 50%;
    transform: translateX(-50%);
  }
  .nav-links {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 0;
    height: calc(100vh - 4rem);
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.9);
    outline: 4rem solid rgba(0, 0, 0, 0.9);
    pointer-events: none;
    opacity: 0;
    transition: all 0.5s;
  }
  .show .nav-links {
    opacity: 1;
    pointer-events: all;
  }
  .nav-links > div {
    width: 100%;
  }
  .nav-links a,
  .nav-links a.spaced {
    display: block;
    font-size: 3rem;
    margin: 0 0 !important;
    color: white !important;
    transition: all 1s;
  }

  .show .nav-links a {
    margin: 8% 0 !important;
  }
  .legal {
    text-align: center;
  }
  .legal a {
    float: none;
    display: inline-block;
    margin-bottom: 1rem;
  }
  .legal span {
    display: block;
    opacity: 0;
    margin-bottom: -1rem;
  }
  .menu-link {
    color: white;
    display: block;
    left: 0;
    font-size: 4rem;
    top: 0rem;
    position: relative;
    z-index: 11;
  }
  .noscroll .menu-link,
  .noscroll .social {
    color: white !important;
  }
  .noscroll #header .logo {
    filter: contrast(0) brightness(200%);
  }
  .social {
    top: 1rem;
  }

  #header .logo {
    width: 8rem;
  }

  #header.scrolled .logo {
    width: 6rem;
  }

  #header.scrolled .social {
    top: 0.8rem;
  }
  .banner .slide,
  .banner .placeholder {
    overflow: hidden;
  }
  .banner img {
    width: 200%;
    max-width: 200%;
    left: -50%;
  }
  .banner span {
    font-size: 4rem;
    bottom: 12rem;
    padding-bottom: 2.5rem;
  }
  .content {
    margin-top: 4rem;
  }
  .section::after {
    display: none !important;
  }
  #video {
    opacity: 0.8;
    filter: contrast(1.25);
  }


}

@media screen and (max-width: 700px) {
  .section,
  .section.timelapse,
  .section:nth-child(even) {
    grid-template-columns: 1fr !important;
    grid-template-areas: "text" "image";
    border-bottom: 0;
    padding-bottom: 0;
  }

    
.section.no-shadow {
  border:0;
  margin-top:0;
  padding: 0;
}
}

@media screen and (max-width: 500px) {
  h1 {
    font-size: 2.5rem;
  }
  h2 {
    font-size: 2.5rem;
  }
  .social {
    top: 2.5rem;
    width: 33%;
  }
  .intro-main {
    font-size: 3.5rem;
  }
  .intro-sub {
    font-size: 2.2rem;
  }
  .menu-link {
    top: 2.1rem;
  }
  #header.scrolled .menu-link {
    top: 0rem;
  }
  #header.scrolled .social {
    top: 0.8rem;
  }
  .intro {
    top: 48%;
  }
  .banner span {
    font-size: 3rem;
    bottom: 9rem;
    padding-bottom: 2rem;
  }
}

@media screen and (max-width: 400px) {
  .intro-actions a {
    padding: 1.5rem 2rem;
    font-size: 1.5rem;
  }
  .down {
    bottom: 15%;
  }
  .intro {
    top: 45%;
  }
}
</style>
